// Copied from Youwell.Platform.Web
import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import {
    Typography, CircularProgress, List, ListItem, ListItemText, ListItemIcon,
} from '@material-ui/core';

import * as AuthStore from '../../../app/store/AuthStore';
import urls from '../../../app/urls';
import { OrgIcon } from '../../../common/icons';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    loginHeader: {
    },

    content: {
    },

    progress: {
        marginTop: theme.spacing(1),
    },
    error: {
        marginTop: theme.spacing(1),
    },
});

class SelectRole extends React.Component {
    onSelect = roleId => () => {
        this.props.selectRole(roleId, { redirect: urls.inside.home });
    };

    render() {
        const {
            classes, errorMessage, loading, roles,
        } = this.props;

        if (!roles || roles.length === 0) {
            return (
                <Redirect to={{
                    pathname: `${urls.login}`,
                }}
                />
            );
        }

        return (
            <div className={classes.root}>
                <div className={classes.content}>
                    <Typography variant="subtitle2" gutterBottom className={classes.loginHeader}>
                        <Translate id="header.selectRole" />
                    </Typography>

                    <List component="nav">
                        {roles && roles.map(role => (
                            <ListItem key={role.id} button onClick={this.onSelect(role.id)}>
                                <ListItemIcon>
                                    <OrgIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={role.organizationName}
                                    secondary={<Translate id={`appRoles.${role.role}`} options={{ onMissingTranslation: () => null }} />}
                                />
                            </ListItem>
                        ))}
                    </List>
                    {loading
                        && <CircularProgress className={classes.progress} />}
                    {errorMessage && (
                        <Typography className={classes.error} color="secondary">
                            {errorMessage}
                        </Typography>
                    )}
                </div>
            </div>
        );
    }
}

SelectRole.propTypes = {
    classes: PropTypes.object.isRequired,
    // match: PropTypes.object.isRequired,
    selectRole: PropTypes.func.isRequired,
    roles: PropTypes.array,
    loading: PropTypes.bool,
    errorMessage: PropTypes.string,
};

SelectRole.defaultProps = {
    loading: false,
    errorMessage: null,
    roles: null,
};

const mapStateToProps = state => ({
    roles: state.auth.profileData?.roles,
    loading: state.auth.loading,
    errorMessage: [].concat(state.auth.errors).filter(val => val).join('<br/>'),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(AuthStore.actionCreators, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SelectRole)));
